import _ from 'underscore';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import uiBlocker from '@bingads-webui-component-legacy/uiblocker/index';
import config from '@bingads-webui-component-legacy/config/index';
import { getTrafficEstimationOp } from '@bingads-webui-campaign-legacy/budget/shared/formatter';
import { getSupportedLocationIds } from '@bingads-webui-campaign-legacy/location-targets/util/filters';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const MAX_KEYWORDS_COUNT = 1000;
const MAX_KEYWORD_LENGTH = 100;
const MAX_LOCATION_IDS_COUNT = 2000;
const estimationEndpoint = '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.CampaignTrafficEstimate';

// adinsight has limitation: keyword's length < 200, but follows ui limitation which is 100
function isKeywordLengthInvalid(op) {
  return _.some(op.data.CampaignTrafficEstimate.AdGroupTrafficEstimateParameters, (adgroup) => {
    return _.some(adgroup.KeywordTrafficEstimateParameters, (keyword) => {
      return keyword && keyword.Text && keyword.Text.length >= MAX_KEYWORD_LENGTH;
    });
  });
}

export default function (params, callbacks, options, endPoint = estimationEndpoint, opTransformer, timestamp) {
  const odataHost = config.get('adinsight.odata.url');
  let locations = getSupportedLocationIds(params.locations);

  if (locations.supportedCount > MAX_LOCATION_IDS_COUNT && _.isFunction(callbacks.onServiceNotSupported)) {
    // this case is only for budget and bid suggestion and no notification will show, so no wording here
    // for "Get performance estimates", when count of location ids > 2000, the button will be hided
    callbacks.onServiceNotSupported('', timestamp);
  } else {
    let op = getTrafficEstimationOp(params.adGroup, params.bid, params.budget, locations.items, params.languages);

    // adinsight has limitation: keywords count < 1000
    if (_.sumBy(op.data.CampaignTrafficEstimate.AdGroupTrafficEstimateParameters, (adgroup) => adgroup.KeywordTrafficEstimateParameters.length) >= MAX_KEYWORDS_COUNT) {
      if (_.isFunction(callbacks.onServiceNotSupported)) {
        callbacks.onServiceNotSupported(i18n.get('Budget_TrafficEstimation_MoreKeywordRequestsThanServiceAllowed'), timestamp);
      }
    } else if (isKeywordLengthInvalid(op)) {
      if (_.isFunction(callbacks.onServiceNotSupported)) {
        callbacks.onServiceNotSupported(i18n.get('Budget_TrafficEstimation_MoreKeywordLengthRequestsThanServiceAllowed'), timestamp);
      }
    } else {
      if (_.isFunction(opTransformer)) {
        op = opTransformer(op, params);
      }

      const adGroupTrafficEstimateParameters = _.chain(op)
        .result('data')
        .result('CampaignTrafficEstimate')
        .result('AdGroupTrafficEstimateParameters')
        .value() || [];
      const isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);

      // if user enabled mixed mode campaign creation
      // there might be a scenario that all created ad groups are dynamic ad groups, and they don't have any keyword in it
      // after the parsing of opTransformer there should be no AdGroupTrafficEstimateParameters, which is not acceptable by trafficEstimation API
      // as a result we need to return an empty response manually
      if (adGroupTrafficEstimateParameters.length === 0 && isDSAMixedModeCampaignEnabled && params.campaignType === 'search') {
        callbacks.onSuccess([{ value: [] }], timestamp);
      } else {
        odata.post(endPoint, _.extend(op, {host: odataHost}),
          (dummy, response, textStatus, xhr)  => {
            if (response && xhr && _.isFunction(xhr.getResponseHeader)) {
              response.suggestedBidRequestId = (xhr && xhr.getResponseHeader('x-ms-requestid')) || '';
            }
          },
        )
          .then((...args) => {
            if (_.isFunction(callbacks.onSuccess)) {
              callbacks.onSuccess(...args, timestamp );
            }
          })
          .catch((...args) => {
            if (_.isFunction(callbacks.onRequestError)) {
              callbacks.onRequestError(...args, timestamp);
            }
          })
          .finally(options.spinner ? uiBlocker(options.spinner) : _.noop);
      }
    }
  }
}
